import React from 'react';
import { Box, Button, Flex, Heading, Text } from 'rebass';
import styled from 'styled-components';
import Modal from 'styled-react-modal';
import ExpandingKit from '../static/expandingKit.gif';
import LaughingPeople from '../static/laughingPeople.png';
import { SpecialModalBackground } from '../pages/adminReorderPhysicianConvo/shared';
import ConfirmModal from './ConfirmModal';

const DesktopOnly = styled(Flex)`
  @media screen and (max-width: 950px) {
    display: none;
  }
`;

const MobileOnly = styled(Flex)`
  @media screen and (min-width: 950px) {
    display: none;
  }
`;

const Desktop = ({ onGoToReferral, onClose }) => {
  return (
    <Flex style={{ background: '#2B3B55', flex: 1, width: '100%', overflow: 'hidden' }}>
      <Flex flexDirection={'column'} px="16px" py="24px" alignItems={'center'} flex={1}>
        <Text textAlign={'center'} color="white">
          Know someone with hypothyroidism, or have a family history?
        </Text>
        <Flex justifyContent={'center'} alignItems={'center'} mt={3}>
          <img src={ExpandingKit} height={'100px'} />
        </Flex>
        <Heading textAlign={'center'} color={'white'} mt={4} style={{ fontSize: '28px' }}>
          Give $30, Get $30
        </Heading>
        <Text textAlign={'center'} color={'white'} mt={3} mb={3} fontSize={'13px'}>
          Treat a friend or a family member to $30 off their first kit purchase and get $30 in credit for your next purchase
        </Text>
        <Button onClick={onGoToReferral} variant="pink" mt={4} style={{ background: '#F88471', fontWeight: 400, padding: '6px 28px', height: 'fit-content', fontSize: '13px', fontFamily: 'Poppins' }}>
          Give $30
        </Button>
      </Flex>
      <Flex flex={1} overflow={'hidden'}>
        <img src={LaughingPeople} style={{ objectFit: 'cover', height: '510px', width: '445px', objectPosition: 'bottom' }} />
      </Flex>

      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        onClick={onClose}
        style={{ position: 'absolute', top: 8, right: 8, zIndex: 30, cursor: 'pointer' }}
      >
        <path
          d="M16 2C8.2 2 2 8.2 2 16C2 23.8 8.2 30 16 30C23.8 30 30 23.8 30 16C30 8.2 23.8 2 16 2ZM16 28C9.4 28 4 22.6 4 16C4 9.4 9.4 4 16 4C22.6 4 28 9.4 28 16C28 22.6 22.6 28 16 28Z"
          fill={'rgb(52, 79, 121)'}
        />
        <path d="M21.4 23L16 17.6L10.6 23L9 21.4L14.4 16L9 10.6L10.6 9L16 14.4L21.4 9L23 10.6L17.6 16L23 21.4L21.4 23Z" fill="rgb(52, 79, 121)" />
      </svg>
    </Flex>
  );
};

const Mobile = ({ onGoToReferral, onClose }) => {
  return (
    <Flex
      style={{
        background: '#2B3B55',
        flex: 1,
        width: '100%',
        overflow: 'hidden',
        maxWidth: 'min(80vw, 315px)',
        height: 'min(75vh, 500px)',
        backgroundImage: `url(${LaughingPeople})`,
        backgroundPosition: 'bottom',
        backgroundSize: 'cover',
        position: 'relative',
      }}
    >
      <Flex style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: 'black', opacity: 0.35 }} />
      <Flex flexDirection={'column'} px="16px" py="24px" alignItems={'center'} flex={1} style={{ zIndex: 1 }}>
        <Text textAlign={'center'} color="white">
          Know someone with hypothyroidism, or have a family history?
        </Text>
        <Flex flexDirection={'column'} flex={1} justifyContent={'center'} alignItems={'center'}>
          <Heading textAlign={'center'} color={'white'} style={{ fontSize: '28px' }}>
            Give $30, Get $30
          </Heading>
          <Text textAlign={'center'} color={'white'} mt={3} mb={3} fontSize={'13px'}>
            Treat a friend or a family member to $30 off their first kit purchase and get $30 in credit for your next purchase
          </Text>
          <Button
            onClick={onGoToReferral}
            variant="pink"
            mt={4}
            style={{ background: '#F88471', fontWeight: 400, padding: '6px 28px', height: 'fit-content', fontSize: '13px', fontFamily: 'Poppins' }}
          >
            Give $30
          </Button>
        </Flex>
      </Flex>

      <svg width="26" height="26" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={onClose} style={{ position: 'absolute', top: 8, right: 8, zIndex: 15 }}>
        <path
          d="M16 2C8.2 2 2 8.2 2 16C2 23.8 8.2 30 16 30C23.8 30 30 23.8 30 16C30 8.2 23.8 2 16 2ZM16 28C9.4 28 4 22.6 4 16C4 9.4 9.4 4 16 4C22.6 4 28 9.4 28 16C28 22.6 22.6 28 16 28Z"
          fill="white"
        />
        <path d="M21.4 23L16 17.6L10.6 23L9 21.4L14.4 16L9 10.6L10.6 9L16 14.4L21.4 9L23 10.6L17.6 16L23 21.4L21.4 23Z" fill="white" />
      </svg>
    </Flex>
  );
};

export const ReferralProgramPopup = ({ onClose, isOpen, onGoToReferral }) => {
  return (
    <ConfirmModal
      // displayX
      confirmLabel="OK"
      isOpen={isOpen}
      childrenManaged
      onClose={onClose}
      onConfirm={onClose}
      onBackgroundClick={onClose}
      onEscapeKeydown={onClose}
      cardStyle={{
        padding: 0,
        borderRadius: 0,
      }}
    >
      <Box
        style={{
          margin: '0 auto',
          alignSelf: 'center',
          position: 'relative',
          backgroundColor: 'white',
          display: 'flex',
          flexDirection: 'column',
          maxWidth: '890px',
          minWidth: 'initial',
          maxHeight: '510px',
          overflow: 'hidden',
        }}
      >
        <MobileOnly>
          <Mobile onGoToReferral={onGoToReferral} onClose={onClose} />
        </MobileOnly>
        <DesktopOnly>
          <Desktop onGoToReferral={onGoToReferral} onClose={onClose} />
        </DesktopOnly>
      </Box>
    </ConfirmModal>
  );
};
